import { render, staticRenderFns } from "./CreatePricingPlanSidebar.vue?vue&type=template&id=5fd9fdc7&"
import script from "./CreatePricingPlanSidebar.vue?vue&type=script&lang=js&"
export * from "./CreatePricingPlanSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CreatePricingPlanSidebar.vue?vue&type=style&index=0&id=5fd9fdc7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports